export const SITE_EN = 'delightAi_en_US'
export const SITE_KO = 'delightAi_ko_KR'
export const SITE_JA = 'delightAi_ja_JP'

export function siteHandleFromPath(path: string): string {
  if (path === '/ko' || path === '/ko/' || path.startsWith('/ko/')) {
    return SITE_KO
  }

  if (path === '/ja' || path === '/ja/' || path.startsWith('/ja/')) {
    return SITE_JA
  }

  return SITE_EN
}

export function localePrefix(siteHandle: string): string {
  if (siteHandle === SITE_KO) return '/ko'
  if (siteHandle === SITE_JA) return '/ja'
  return ''
}

export function homePath(siteHandle: string): string {
  return localePrefix(siteHandle) || '/'
}

export function htmlLang(siteHandle: string): string {
  if (siteHandle === SITE_KO) return 'ko-KR'
  if (siteHandle === SITE_JA) return 'ja'
  return 'en-US'
}

export function isLocaleHomeSlug(slug: string): boolean {
  return slug === 'ko' || slug === 'ja'
}
